<template>
  <div>
    <user-list-direct-chat
      :listUser="userOpts"
      @searchUser="searchUser"
      :roomId="roomId"
      @loadMoreUser="loadMoreUser"
      ref="userListRefs"
    ></user-list-direct-chat>
  </div>
</template>
<script>
import UserListDirectChat from "@/pages/ChatRoom/Sidebar/Tabs/DirectChat/UserListDirectChat";
import { setTimezone } from "@/pages/ChatRoom/Sidebar/Components/helpers";
import { mapGetters } from "vuex";
import { isMessageFromGeneralGroup } from "@/helpers/chat";
import { service_paths } from "../../../../../constants/Services";

export default {
  components: { UserListDirectChat },
  props: ["roomChatSupporterId"],
  inject: ["routerToRoomChat"],
  data() {
    return {
      roomId: null,
      infoDirect: null,
      userOpts: [],
      countOfRecords: 50,
      isLoading: false
    };
  },
  created() {
    this.searchUser();
  },
  computed: {
    ...mapGetters("chat", ["socketEvent"])
  },
  watch: {
    roomChatSupporterId: function(newVal) {
      if (!newVal) return;
      const res = {
        full_name: "supporter",
        avatar: "",
        id: newVal
      };
      this.$refs.userListRefs.currentId = newVal;
      this.routerToRoomChat(res);
    },
    socketEvent: {
      deep: true,
      handler: function(value) {
        this.setSocketEvent(value);
      }
    }
  },
  methods: {
    loadMoreUser() {
      let offset =
        Math.floor(this.userOpts.length / this.countOfRecords) *
        this.countOfRecords;
      this.searchUser(true, this.countOfRecords, offset);
    },
    unSelectRoomChat() {
      this.$refs.userListRefs.currentId = null;
    },
    setRoomId(event) {
      let roomId = null;
      let firstArg = event?.fields?.args[0];
      if (firstArg === "inserted") return;
      let isGroup = event?.fields?.fname;
      if (isGroup) return;
      roomId = event.fields?.args[1]?._id;
      return roomId;
    },
    async setSocketEvent(event) {
      //config for room socket , using when can't listen notify-user from socket
      let roomIdFromRoom = this.setRoomId(event);
      //config for notify socket
      let roomIdFromUser = event?.fields?.args[0]?.payload?.rid;
      if (isMessageFromGeneralGroup(event?.fields?.args[1]?._id)) return;
      let roomId = roomIdFromRoom || roomIdFromUser;
      if (!roomId) return;
      this.roomId = roomId;
      let indexChanged = null;
      this.userOpts.forEach((item, index) => {
        if (item.id === roomId) {
          indexChanged = index;
          item.time = setTimezone(new Date(), true);
          let condition = this.$refs.userListRefs.currentId === roomId;
          if (!roomIdFromRoom) {
            item.unread = condition ? (item.unread = 0) : +item.unread + 1;
          }
        }
      });
      if (indexChanged !== null) {
        this.userOpts.unshift(this.userOpts[indexChanged]);
        this.userOpts.splice(indexChanged + 1, 1);
      } else {
        if (this.isLoading) return;
        this.searchUser(false, undefined, undefined, true);
      }
    },

    searchUser(overlayLoading, count, offset, isClearList) {
      this.isLoading = true;
      return this.$axios
        .get(
          service_paths.chat + "/direct",
          { count: count || this.countOfRecords, offset: offset || 0 },
          undefined,
          undefined,
          undefined,
          undefined,
          overlayLoading
        )
        .then(({ data }) => {
          this.setListUser(data, isClearList);
        });
    },
    setListUser(data, isClearList) {
      if (isClearList) this.userOpts = [];
      let newData = data.map(item => {
        return {
          ...item,
          time: setTimezone(item.last_message_at),
          fullName: item?.user_no_sql?.full_name,
          avatar: item?.user_no_sql?.avatar_url
        };
      });
      this.userOpts = [...this.userOpts, ...newData];
      this.isLoading = false;
      this.$refs.userListRefs.isShowLoading =
        (data.length % this.countOfRecords === 0 ||
          this.userOpts.length >= this.countOfRecords) &&
        data.length > 0;
    },
    async getQueryDirectId(directId) {
      const { data } = await this.$axios.get(
        `${service_paths.chat}/room/${directId}`
      );
      const formRedirect = {
        full_name: data.username,
        id: data.room_id,
        avatar: data.user_no_sql?.avatar_url
      };
      this.routerToRoomChat(formRedirect);
      this.$refs.userListRefs.currentId = formRedirect.id;
      this.$router.replace({ query: {} });
    }
  },
  mounted() {
    const directId = this.$route.query.direct_id;
    if (!directId) return;
    this.getQueryDirectId(directId);
  },
  provide() {
    return {
      searchUser: this.searchUser
    };
  }
};
</script>
<style lang="scss" scoped></style>
